function initIngredientsCarousel() {
  new Swiper(".ingredients-swiper", {
    slidesPerView: 3,
    spaceBetween: 30,
    loop: true,
    watchOverflow: true,
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 20,
        slidesPerGroup: 1,
      },
      769: {
        slidesPerView: 2,
        spaceBetween: 30,
        slidesPerGroup: 2,
      },

      1300: {
        slidesPerView: 3,
        spaceBetween: 30,
        slidesPerGroup: 3,
      },
    },
    on: {
      init: function () {
        this.slides[this.activeIndex].classList.add("swiper-slide-active");
      },
      slideChange: function () {
        this.slides.forEach((slide) =>
          slide.classList.remove("swiper-slide-active")
        );
        this.slides[this.activeIndex].classList.add("swiper-slide-active");
      },
    },
  });
}

// Init
document.readyState !== "loading"
  ? initIngredientsCarousel()
  : document.addEventListener("DOMContentLoaded", initIngredientsCarousel);
